import { Engine } from "../Engine";
import { InputMouseEvent } from "./InputHandler";
import { IDrawableObject } from "../Object/ObjectManager";
import { Ray } from "@spi/Common/Math";
import { Camera } from "../View";
import { DefaultPicker } from "./DefaultPicker";

export interface Picker {
    pick(camera: Camera, x: number, y: number): IDrawableObject;
}

export class MouseObjectInteraction {

    private lastMouseMoveEvent: InputMouseEvent;
    private currentHoverObject: IDrawableObject;
    private picker: Picker;

    constructor(private engine: Engine) {
        this.init();
    }

    private init() {
        this.engine.tickEventManager.registerTimeEvent(() => {
            if (this.lastMouseMoveEvent) {
                this.objectHover(this.lastMouseMoveEvent);
            }
        }, 50);

        this.picker = new DefaultPicker(this.engine);
    }

    private objectHover(e: InputMouseEvent) {

        let x = e.position.x;
        let y = e.position.y;

        let obj = this.picker.pick(this.engine.activeCamera, x, y);

        if (obj && obj.interaction) {

            obj.interaction.onHoverIn();
        } else {
            let hitMap = this.engine.activeScene.pickingManager.getRayIntersections(this.getRay(e));
            hitMap.forEach((value, key) => {
                value.callback(key, 'mouseMove', value.hits);
            });
        }

        if (this.currentHoverObject && this.currentHoverObject !== obj) {
            this.currentHoverObject.interaction.onHoverOut();
        }

        if (obj && obj.interaction) {
            this.currentHoverObject = obj;
        }
    }

    private getRay(e: InputMouseEvent): Ray {
        return this.engine.activeCamera.getRay(e.position.x, e.position.y)
    }

    public mouseMoveEvent(e: InputMouseEvent) {
        this.lastMouseMoveEvent = e;
        this.objectHover(e);
    }

    public mouseUpEvent(e: InputMouseEvent) {
        let obj = this.picker.pick(this.engine.activeCamera, e.position.x, e.position.y);

        if (obj && obj.interaction) {
            obj.interaction.onPressRelease();
        } else {
            let hitMap = this.engine.activeScene.pickingManager.getRayIntersections(this.getRay(e));
            let done = false;

            hitMap.forEach((value, key) => {
                if (!done) { // TODO: This feels dirty, is there a different way to loop over Sets/Maps?
                    done = value.callback(key, 'mouseUp', value.hits);
                }
            });
        }

    }

    public mouseDownEvent(e: InputMouseEvent) {
        let obj = this.picker.pick(this.engine.activeCamera, e.position.x, e.position.y);

        if (obj && obj.interaction) {
            obj.interaction.onPressDown();
        } else {
            let hitMap = this.engine.activeScene.pickingManager.getRayIntersections(this.getRay(e));
            hitMap.forEach((value, key) => {
                value.callback(key, 'mouseDown', value.hits);
            });
        }

    }
}